module.exports = __webpack_public_path__ + "img/Chef_Herrera.b55e7a05.jpg";